import {
  takeEvery,
  put,
  cancel,
  delay,
} from 'redux-saga/effects';

import { isGroupOrder } from 'features/order-tracker/utils';
import { PAGE_TYPE } from 'features/order-tracker/services/constants';
import { ANALYTICS_ERROR_MSG } from './services/constants';
import {
  INIT_SUMMARY_PAGE_START,
  setDataToStore,
  fetchGroupOrder,
  fetchOrderSummaryRequests,
  setAPIFailed,
  clearAnalytics,
  clearState,
  clearCachedData,
} from '../actions';

import { analyticsService } from './services/analyticsService';
import { orderTrackerService } from './services/orderTrackerService';

declare global {
  interface Window {
    __satelliteLoaded?: boolean;
  }
}

export function* initApplication(): Generator {
  yield put(clearAnalytics());
  yield put(clearState());
  yield put(clearCachedData());
  orderTrackerService.initData();
  const { orderReference, postcode, isTrackingDataValid } = orderTrackerService;

  let waitForAnalyticsTimes = 20;
  while (waitForAnalyticsTimes) {
    if (window.__satelliteLoaded) break; // eslint-disable-line
    waitForAnalyticsTimes = (yield delay(100, waitForAnalyticsTimes - 1)) as number;
  }

  analyticsService.trackAnalytics(PAGE_TYPE.waitingRoom);

  if (!isTrackingDataValid()) {
    yield put(setAPIFailed({ isGeneralAPIFailed: true, isFetching: false }));
    analyticsService.trackAnalytics(PAGE_TYPE.error, { trackingError: ANALYTICS_ERROR_MSG });
    yield cancel();
  }

  yield put(setDataToStore({ orderReference, postcode }));

  isGroupOrder(orderReference) ? yield put(fetchGroupOrder()) : yield put(fetchOrderSummaryRequests());
}

export function* watchInitApplication(): Generator {
  yield takeEvery(INIT_SUMMARY_PAGE_START, initApplication);
}
